
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thinking/[slug]",
      function () {
        return require("private-next-pages/thinking/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thinking/[slug]"])
      });
    }
  